<template>
  <div class="east-cred-layout">
    <div class="east-cred-layout__center is-scrollable">
      <div class="east-cred-layout__center__content">
        <div>
          <east-block-product-detail
             mode="selected-serving"
            :contentID="contentID"
            :contentType="contentType"
            :servingSizeID="formData.content_serving_size_id"
            :amount="formData.content_amount"
            :entityType="entityType"
            :contentDetails="_get(ContentStuffToEatDetails, 'data')">
          </east-block-product-detail>
        </div>
        <div class="form-east-block-layout">
          <el-form
            :model="formData"
            label-width="12em">
            <section>
              <h4 class="section-title">
                {{ $t('label.contents_quantity') }}
              </h4>
              <div class="section-items">
                <el-form-item :label="$t('label.amount')" prop="content_amount">
                  <el-col :span="24">
                    <el-input-number
                      class="w-100"
                      v-model="formData.content_amount"
                      @change="onInputChange">
                    </el-input-number>
                  </el-col>
                </el-form-item>
                <el-form-item :label="$t('label.serving_size')" prop="content_serving_size_id">
                  <el-col :span="24">
                    <el-select
                      class="w-100"
                      placeholder="Select"
                      v-model="formData.content_serving_size_id"
                      @change="dispatchNutritionPrediction">
                      <el-option-group
                         v-for="servingGroup in availableServing"
                         v-if="!_isEmpty(servingGroup.list)"
                        :label="servingGroup.title"
                        :key="servingGroup.key">
                        <el-option
                           v-for="item in servingGroup.list"
                          :label="`${item.title || item.description} (${item.weight_gr}g)`"
                          :key="item.id"
                          :value="item.id">
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-col>
                  <el-col :span="24">
                    <el-button
                       icon="plus"
                       size="small"
                       class="w-100 extra-margin-top-0-5"
                      :class="{ 'is-active el-button--primary': showAddServingSize }"
                      @click="toggleAddServiceSize">
                      {{ $t('label.add_new_serving_size') }}
                    </el-button>
                  </el-col>
                </el-form-item>
                <add-serving-size
                   v-if="showAddServingSize"
                  @cancel="handdleCancelServingSizeEvent"
                  @submit="handleAddServingSizeEvent">
                </add-serving-size>
              </div>
            </section>
          </el-form>
        </div>

        <div class="form-east-block-layout">
          <section>
            <h4 class="section-title">{{ $t('label.nutrition_prediction') }}</h4>

            <div v-if="manualNutrition && !showPredictionAnyway" class="section-items">
              <p>{{ $t('label.prediction_manual_nutrition_mode') }}</p>
              <p><el-button @click="handleShowPredictionAnyway" size="mini" type="text">{{ $t('label.show_me_anyway') }}...</el-button></p>
            </div>

            <div v-else class="section-items" style="min-height: 20em">
              <nuttrema-notification
                 v-if="manualNutrition"
                 type="orange"
                 icon="far fa-exclamation"
                 style="margin-bottom: 1em"
                :title="$t('label.note')"
                :html="$t('label.prediction_manual_nutrition_mode_note')">
              </nuttrema-notification>

              <nuttrema-loader v-if="isNutritionPredictionLoading" :showText="false"></nuttrema-loader>
              <nutrition-facts
                 v-else
                 mode="select-serving-size"
                 element-loading-background="rgba(255,255,255, 0.25)"
                 v-loading="StuffToEatNutritionPrediction.fetching"
                :productNutritionFacts="StuffToEatNutritionPrediction.data"
                @servingSizeChange="onServingSizeChange">
              </nutrition-facts>
            </div>
          </section>
        </div>
        <!-- end ~ form-east-block-layout -->

      </div>
      <!-- end ~ east-cred-layout__center__content -->

    </div>
    <!-- end ~ east-cred-layout__center -->

    <div class="east-cred-layout__bottom">
      <nav class="nav" v-if="entityContentID !== -1">
        <div class="nav-left">
          <div class="nav-item">
            <el-button :loading="saving && action === 'save'" type="primary" size="small" @click="handleFormSubmit">
              {{ $t('label.save_changes') }}
            </el-button>
            <el-button size="small" type="text" @click="handleCancel">{{ $t('label.cancel') }}</el-button>
          </div>
        </div>
        <div class="nav-right nav-right--grow-less">
          <div class="nav-item" v-if="entityContentID">
            <popover-question-alert
               slot="bottom-right"
               buttonTitle="label.remove"
               buttonType="danger"
               popoverWidth="280"
               popoverTitle="label.remove"
               popoverText="label.remove_sure"
               popoverPlacement="top-end"
               buttonSize="small"
              :loading="saving && action === 'remove'"
              :popoverShouldShow="true"
              @confirmed="handleRemoveContentEvent">
            </popover-question-alert>
          </div>
        </div>
      </nav>
      <nav class="nav" v-else>
        <div class="nav-left">
          <div class="nav-item">
            <el-button type="primary" size="small" @click="handleFormSubmit" :loading="saving && action ==='save'">
              {{ $t('label.add_new') }}
            </el-button>
          </div>
        </div>
        <div class="nav-right nav-right--grow-less">
          <div class="nav-item">
            <el-button size="small" type="text" @click="handleCancel">{{ $t('label.cancel') }}</el-button>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { assign, get, omitBy, isNil } from 'lodash';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';
import NuttremaNotification from 'components/ui/alert/nuttrema-notification';

import EastBlockProductDetail from 'components/pages/professional/stuff-to-eat/shared/entity/cmpt-east-block-product-detail';
import NutritionFacts from 'components/ui/nutrition-information/nutrition-facts';
import AddServingSize from 'components/pages/professional/stuff-to-eat/shared/details/serving-sizes/cmpt-add-serving-size';

export default {
  name: 'cmpt-entity-content-cred-stuff-to-eat',
  props: {
    entityContentID: {
      required: false,
      default: null,
    },
    entityID: {
      required: true,
      default: null,
    },
    entityType: {
      required: true,
      default: null,
    },
    contentID: {
      required: true,
      default: null,
    },
    contentType: {
      required: true,
      default: null,
    },
    contentAmount: {
      required: false,
      default: 1,
    },
    MainStuffToEatDetails: {
      required: true,
    },
    ContentStuffToEatDetails: {
      required: true,
    },
    availableServing: {
      required: true,
      default: null,
    },
    selectedServing: {
      required: true,
      default: null,
    },
    saving: {
      default: false,
    },
  },
  components: {
    NutritionFacts,
    AddServingSize,
    NuttremaLoader,
    NuttremaNotification,
    PopoverQuestionAlert,
    EastBlockProductDetail,
  },
  data() {
    return {
      showAddServingSize: false,
      manualNutrition: false,
      showPredictionAnyway: false,
      formData: {
        id: '',
        content_amount: '',
        content_serving_size_id: '',
        content_id: '',
        entity_content_id: '',
      },
      timer: null,
      action: null,
    };
  },
  computed: {
    StuffToEatNutritionPrediction() {
      return this.$store.getters.StuffToEatNutritionPrediction(this.entityID);
    },
    isNutritionPredictionLoading() {
      const ready = get(this.StuffToEatNutritionPrediction, 'ready', false);
      const fetching = get(this.StuffToEatNutritionPrediction, 'fetching', true);
      return fetching && !ready;
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    fetchNutritionPrediction() {
      if (this.manualNutrition && !this.showPredictionAnyway) return false;

      return this.$store.dispatch('GetStuffToEatNutritionPrediction', {
        id: this.entityID,
        type: this.entityType,
        query: omitBy(this.formData, (value, key) => key === 'id' || value === -1),
      });
    },
    dispatchNutritionPrediction() {
      this.$nextTick(() => {
        this.fetchNutritionPrediction();
      });
    },
    onInputChange() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.dispatchNutritionPrediction();
      }, 500);
    },
    onServingSizeChange(predictServingSizeID) {
      assign(this.formData, { predict_serving_size_id: predictServingSizeID });
      this.dispatchNutritionPrediction();
    },
    toggleAddServiceSize() {
      this.showAddServingSize = !this.showAddServingSize;
    },
    handleFormSubmit() {
      this.action = 'save';
      this.$emit('submit', {
        id: this.entityID,
        type: this.entityType,
        entityContentID: this.entityContentID,
        data: {
          amount: this.formData.content_amount,
          content_id: this.formData.content_id,
          content_serving_size_id: this.formData.content_serving_size_id,
        },
      });
    },
    handdleCancelServingSizeEvent() {
      this.showAddServingSize = false;
    },
    handleAddServingSizeEvent(payload) {
      console.log('handleAddServingSizeEvent');
      const data = {
        id: this.contentID,
        type: this.contentType,
        payload: omitBy(payload, isNil),
        entityContentID: this.entityContentID,
      };
      this.$emit('addServingSize', data);
    },
    handleRemoveContentEvent() {
      this.action = 'remove';
      this.$emit('removeContent', {
        id: this.entityID,
        type: this.entityType,
        entityContentID: this.entityContentID,
      });
    },
    handleShowPredictionAnyway() {
      this.showPredictionAnyway = true;
      this.dispatchNutritionPrediction();
    },
  },
  watch: {
    selectedServing(newVal, oldVal) {
      const changed = Number(newVal) !== Number(oldVal);
      if (newVal && changed) {
        this.formData.content_serving_size_id = newVal;
        this.dispatchNutritionPrediction();
        this.toggleAddServiceSize();
      }
    },
  },
  created() {
    this.formData = {
      id: this.entityID,
      entity_content_id: this.entityContentID,
      content_id: this.contentID,
      content_serving_size_id: this.selectedServing,
      content_amount: this.contentAmount,
    };

    this.manualNutrition = get(this.MainStuffToEatDetails, 'data.manual_nutrition') || false;
    this.fetchNutritionPrediction();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/contents/cmpt-stuff-to-eat-cred-content.vue